import * as React from 'react';
import {AppRouting, Roles} from '../../AppConstants';
import { NavLink } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import styles from './Sidebar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faArrowRightFromBracket,
    faCircleInfo, IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import administrationIcon from '../Icons/buss_icon_administration_rgb_weiss.svg';
import { LocalStorageGet, LocalStorageSet } from '../../Services/Helpers';
import { authService } from '../../index';
import {popoverDialogStore} from "../PopoverDialog/PopoverDialog";
import {TermsAndConditionsContent} from "./Components/TermsAndConditionsContent";

type Routes = {
    url: string,
    icon?: IconDefinition,
    iconSVG?: string,
    label: string,
    role?: Roles
}
const LS_NAME = 'sidebarCollapsed';
export const Sidebar = () => {
    const [collapsed, setCollapsed] = React.useState<boolean>(LocalStorageGet<boolean>(LS_NAME) || false);
    const { userRole } = authService;

    const routes: Routes[] = [
        {
            url: AppRouting.Users,
            label: 'User Configuration',
            iconSVG: administrationIcon,
        },
        {
            url: AppRouting.Organizations,
            label: 'Company Configuration',
            iconSVG: administrationIcon,
            role: Roles.GlobalAdmin
        }
    ];

    const _toggle = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        LocalStorageSet<boolean>(LS_NAME, !collapsed);
        setCollapsed(!collapsed);
    };
    const _signOut = () => {
        void authService.signOut();
    };
    const renderTermsAndConditionsContent = () => {
        return (<TermsAndConditionsContent />);
    }
    return (
        <div className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
            <div className={styles.body}>
                <div className={styles.logo}>
                    <span
                        className={styles.img}/>
                </div>
                <div className={styles.menu}>
                    {routes.map(route => {
                        const { icon, iconSVG, label, url, role } = route;
                        if(role && role !== userRole) {
                            return null;
                        }
                        return (
                            <NavLink key={url} className={styles.link} activeClassName={styles.active} to={url}>
                                { iconSVG && <ReactSVG src={iconSVG} className={styles.icon}/> }
                                { icon && <FontAwesomeIcon icon={icon} className={styles.icon}/>}
                                <span className={styles.label}>{label}</span>
                            </NavLink>
                        );
                    })}
                </div>
            </div>
            <div className={styles.footer}>
                <div className={styles.configs} title={'Terms and Conditions'} onClick={(e) => {
                    e.stopPropagation();
                    popoverDialogStore.showPopover(renderTermsAndConditionsContent())}}>
                    <div className={styles.link} >
                        <FontAwesomeIcon icon={faCircleInfo} className={styles.icon}/>
                    </div>
                </div>
                <div className={styles.info} >
                    <span>{authService.currentUser?.name || authService.currentUser?.username}</span>
                    <FontAwesomeIcon icon={faArrowRightFromBracket} className={styles.icon} onClick={_signOut}/>
                </div>
            </div>
            <div className={styles.toggle} onClick={_toggle}>
                <FontAwesomeIcon icon={faArrowLeft} className={styles.icon}/>
            </div>
        </div>
    );
};
